var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "list-unstyled" }, [
    _c("div", { staticClass: "left" }, [
      _c("div", [
        _c("strong", [_vm._v(_vm._s(_vm.$t("message.forWindows")))]),
        _vm._v(" "),
        _c("hr"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("1")]),
          _vm._v("\n            ,\n            "),
          _c("b-badge", [_vm._v("2")]),
          _vm._v("\n            ,\n            "),
          _c("b-badge", [_vm._v("3")]),
          _vm._v(
            "\n            ...\n            " +
              _vm._s(_vm.$t("message.shortcut_desc_num")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("CTRL")]),
          _vm._v("\n            +\n            "),
          _c("b-badge", [_vm._v("M")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.openPrivateChat")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("CTRL")]),
          _vm._v("\n            +\n            "),
          _c("b-badge", [_vm._v("↑")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.closeActiveChat")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("CTRL")]),
          _vm._v("\n            +\n            "),
          _c("b-badge", [_vm._v("→")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.nextChatFromActive")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("CTRL")]),
          _vm._v("\n            +\n            "),
          _c("b-badge", [_vm._v("←")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.previousChatFromActive")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("CTRL")]),
          _vm._v("\n            +\n            "),
          _c("b-badge", [_vm._v("↓")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.hideActiveChat")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("CTRL")]),
          _vm._v("\n            +\n            "),
          _c("b-badge", [_vm._v("↓")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.archiveChatKey")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("CTRL")]),
          _vm._v("\n            +\n            "),
          _c("b-badge", [_vm._v(",")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.chatCopilot")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("ESC")]),
          _vm._v(
            "\n            " + _vm._s(_vm.$t("message.escKey")) + "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("F1")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.focusInput")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("F2")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.firsthiddenChat")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("F3")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.firstChatWaiting")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("F4")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.previousOpenedChat")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("CTRL")]),
          _vm._v("\n            +\n            "),
          _c("b-badge", [_vm._v(",")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.copilot_desc_num")) +
              "\n        "
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "right" }, [
      _c("div", { staticStyle: { "margin-top": "10px" } }, [
        _c("strong", [_vm._v(_vm._s(_vm.$t("message.forMac")))]),
        _vm._v(" "),
        _c("hr"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("1")]),
          _vm._v("\n            ,\n            "),
          _c("b-badge", [_vm._v("2")]),
          _vm._v("\n            ,\n            "),
          _c("b-badge", [_vm._v("3")]),
          _vm._v(
            "\n            ...\n            " +
              _vm._s(_vm.$t("message.shortcut_desc_num")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("CTRL")]),
          _vm._v("\n            +\n            "),
          _c("b-badge", [_vm._v("M")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.openPrivateChat")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("CTRL")]),
          _vm._v("\n            +\n            "),
          _c("b-badge", [_vm._v("↑")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.closeActiveChat")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("OPT")]),
          _vm._v("\n            +\n            "),
          _c("b-badge", [_vm._v("→")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.nextChatFromActive")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("OPT")]),
          _vm._v("\n            +\n            "),
          _c("b-badge", [_vm._v("←")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.previousChatFromActive")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("OPT")]),
          _vm._v("\n            +\n            "),
          _c("b-badge", [_vm._v("↓")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.hideActiveChat")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("CTRL")]),
          _vm._v("\n            +\n            "),
          _c("b-badge", [_vm._v("↓")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.archiveChatKey")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("CTRL")]),
          _vm._v("\n            +\n            "),
          _c("b-badge", [_vm._v(",")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.chatCopilot")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("ESC")]),
          _vm._v(
            "\n            " + _vm._s(_vm.$t("message.escKey")) + "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("F1")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.focusInput")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("F2")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.firsthiddenChat")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("F3")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.firstChatWaiting")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("F4")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.previousOpenedChat")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-badge", [_vm._v("Command")]),
          _vm._v("\n            +\n            "),
          _c("b-badge", [_vm._v(",")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.copilot_desc_num")) +
              "\n        "
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }